import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import { useContext } from "react";
import cardComponentContext from "./cardComponentContext.mjs";
import useThemeProps from "./useThemeProps.mjs";
import parseStyle from "./parseStyle.mjs";
import Stack from "./Stack.mjs";
function CardMeta(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "CardMeta"
  });
  let {
    children,
    color,
    style,
    ...restProps
  } = props;
  const {
    color: backgroundColor
  } = useContext(cardComponentContext);
  color ?? (color = [backgroundColor, "text", "-500"]);
  return /* @__PURE__ */jsx(Stack, {
    direction: "row",
    justifyContent: "start",
    divider: {
      style: {
        borderWidth: "2px"
      }
    },
    css: /* @__PURE__ */css("color:", theme.getColor(color), ";font-size:0.875rem;font-weight:600;line-height:125%;letter-spacing:-0.01px;", parseStyle(style, theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CardMeta;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9qZWFuZnJlZHJpay9wcm9qZWN0cy93c3VpL3BhY2thZ2VzL2Jhc2Uvc3JjL0NhcmRNZXRhLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQmMiLCJmaWxlIjoiL1VzZXJzL2plYW5mcmVkcmlrL3Byb2plY3RzL3dzdWkvcGFja2FnZXMvYmFzZS9zcmMvQ2FyZE1ldGEuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IGNhcmRDb21wb25lbnRDb250ZXh0IGZyb20gXCIuL2NhcmRDb21wb25lbnRDb250ZXh0XCI7XG5pbXBvcnQgdXNlVGhlbWVQcm9wcyBmcm9tIFwiLi91c2VUaGVtZVByb3BzLmpzeFwiO1xuaW1wb3J0IHBhcnNlU3R5bGUgZnJvbSBcIi4vcGFyc2VTdHlsZVwiO1xuaW1wb3J0IFN0YWNrIGZyb20gXCIuL1N0YWNrLmpzeFwiO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBDYXJkTWV0YShwcm9wcykge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIHByb3BzID0gdXNlVGhlbWVQcm9wcyh7IHByb3BzLCBuYW1lOiBcIkNhcmRNZXRhXCIgfSk7XG4gIGxldCB7IGNoaWxkcmVuLCBjb2xvciwgc3R5bGUsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gIGNvbnN0IHsgY29sb3I6IGJhY2tncm91bmRDb2xvciB9ID0gdXNlQ29udGV4dChjYXJkQ29tcG9uZW50Q29udGV4dCk7XG4gIGNvbG9yID8/PSBbYmFja2dyb3VuZENvbG9yLCBcInRleHRcIiwgXCItNTAwXCJdO1xuICByZXR1cm4gKFxuICAgIDxTdGFja1xuICAgICAgZGlyZWN0aW9uPVwicm93XCJcbiAgICAgIGp1c3RpZnlDb250ZW50PVwic3RhcnRcIlxuICAgICAgZGl2aWRlcj17eyBzdHlsZTogeyBib3JkZXJXaWR0aDogXCIycHhcIiB9IH19XG4gICAgICBjc3M9e2Nzc2BcbiAgICAgICAgY29sb3I6ICR7dGhlbWUuZ2V0Q29sb3IoY29sb3IpfTtcbiAgICAgICAgZm9udC1zaXplOiAwLjg3NXJlbTtcbiAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgbGluZS1oZWlnaHQ6IDEyNSU7XG4gICAgICAgIGxldHRlci1zcGFjaW5nOiAtMC4wMXB4O1xuICAgICAgICAke3BhcnNlU3R5bGUoc3R5bGUsIHRoZW1lKX1cbiAgICAgIGB9XG4gICAgICB7Li4ucmVzdFByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L1N0YWNrPlxuICApO1xufVxuIl19 */"),
    ...restProps,
    children
  });
}
export { CardMeta as default };